module.exports = __webpack_public_path__ + "static/media/chrome-brands.1139a84d.svg";